

import { HttpClient } from '@angular/common/http';
import { NbMenuItem } from '@nebular/theme';

import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

import { Injectable } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class MyMenuService {
  private link=MENU_LINK;  
  menu : NbMenuItem[] = [] //NbMenuItem[]

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private _router: Router,
    private nbIconLibraries:NbIconLibraries
  ) {

    //R: Icon設定
    //this.nbIconLibraries.registerFontPack('包名稱', { packClass: '引用的css 字體名稱', iconClassPrefix: '要拿掉的css class前綴' });
    //使用時 一般class="icon-menu" 這邊使用 icon: { icon: 'menu', pack: 'icomoon' },
    this.nbIconLibraries.registerFontPack('icomoon', { packClass: 'icomoon', iconClassPrefix: 'icon' });

    this.menu = [] 
  }

  //取得菜單
  getMenu(){
    console.log('getMenuXD',this.menu)

    
  
    let USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID');
    let USR_POSEmployeeInfo_ID = this.cookieService.get('USR_POSEmployeeInfo_ID')

     //如果沒有登入就跳轉
    if((!USR_AccountInfo_ID||USR_AccountInfo_ID=="")&&
      (!USR_POSEmployeeInfo_ID||USR_POSEmployeeInfo_ID==""))
    {
      this._router.navigate(['/user/login']); //WEB首頁
      return null 
    }

    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    let sid = (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null    
    this.http.post<any>('api/Permissions/menu',
    {
        USR_AccountInfo_ID: this.cookieService.get('USR_AccountInfo_ID') ,
        USR_EmployeeInfo_ID: this.cookieService.get('USR_EmployeeInfo_ID'),
        USR_POSEmployeeInfo_ID:this.cookieService.get('USR_POSEmployeeInfo_ID'),
        ORG_Company_ID:parseInt(this.cookieService.get('ORG_Company_ID')),
        ORG_Store_ID: sid == 0 ? null : sid,
    }
    ).subscribe({
      next: data => {
        this.menu.splice(0,this.menu.length)
        if(this.menu.length>0) return

        let canLink = []

        if( data.list.length == 0){
          return null
        }

        //menu顯示
        data.list.forEach(element => {
          //1層menu
          var menuItem: NbMenuItem = new NbMenuItem();
          menuItem.title = element.ModuleName;
          menuItem.data = element.ModuleCode;
          menuItem.icon = { icon: element.Path, pack: 'icomoon' },
          menuItem.children = [];

          let cid = this.cookieService.get('ORG_Company_ID')
          let stag = sid ? 's'+sid : 'c'+cid

          //2層1層menu
          element.Child.forEach(childItem => {
            var childMenu: NbMenuItem = new NbMenuItem();
            childMenu.title = childItem.FunctioningName;
            childMenu.data = childItem.FunctioningCode;
            childMenu.icon = { icon: childItem.Path, pack: 'icomoon' }
            childMenu.link=this.link[childMenu.data];
            // childMenu.link=this.link[childMenu.data]+'/'+stag;
            
            menuItem.children.push(childMenu);

            canLink.push(childMenu.link)
          });         
          this.menu.push(menuItem)
        });

        let all = new Array();
        for(let x in MENU_LINK) all[all.length]=x;

        //大權限切換門市時 如果當前處於沒有權限的頁面 要跳轉
        if(canLink.findIndex(x=>x== this._router.url) == -1 && 
          canLink.findIndex(x=>x== all) > -1) {
             //預設進入
          this._router.navigate(['/Home']);
        }
      

        // 隱藏版
        // Dev.forEach(x=>{
        //   this.menu.push(x)
        // })

      },
      error: error => {
      }
    })
    

    
  }

  //登出
  logout() {
    this.cookieService.delete('USR_AccountInfo_ID','/');
    this.cookieService.delete('USR_EmployeeInfo_ID','/');
    this.cookieService.delete('NickName','/');
    this.cookieService.delete('PhotoURL','/');
    this.cookieService.delete('ORG_Company_ID','/');
    this.cookieService.delete('ORG_Store_ID','/');
    this.cookieService.delete('CompanyName','/');
    this.cookieService.delete('USR_POSEmployeeInfo_ID','/');

    this._router.navigate(['/user/login']); //登入畫面
  }
  




}

//menuAPI對應路由
export const MENU_LINK = {
  'POSPermissionManage': '/Auth/EmplyeeGroup',//POS權限設定管理
  'ContractManage': '/Auth/ContractManage',//POS權限設定管理
  
  'PermissionGroupManage':'/permissiongroup/list',//權限群組帳號管理

 
  'UsingPOSMenu':'/Product/UsingPosMenu' ,//'商品設定
  'ProductSetting':'/Product/Setting', //商品設定
  'MenuSetting':'/Product/Menu', //菜單設定
  'SaleCloseSetting':'/Product/SaleClose', //停售設定
  
  //PayFlow
  'DiscountSetting':'/PosOrder/Discount',  //優惠設定
  'PaymentManage': '/PosOrder/Payment',//多元支付
  'ServiceFeeManage': '/PosOrder/Servicecharge',//服務費管理
  'CreditMachineManage':'/PosOrder/CreditMachineManage', //信用卡機設定
  'InvoiceSetting':'/Store/InvoiceSetting', //電子發票設定
  'WordTrackManage':'/Store/WordTrack', //字軌設定

  //SysSetting
  'ButtonSetting':'/PosOrder/ButtonSetting', //按鈕設定設定
  'ButtonPermissionManage':'/PosOrder/ButtonAuth', //按鈕設定設定
  'ReasonSetting':'/PosOrder/ReasonSetting', //操作事由
  'POSMachineManage': '/Store/PosMachine',//POS機設定
  'CDSMachineManage': '/Store/CDSMachine',//CDS機設定  
  'KioskMachineManage': '/Store/KioskMachine',//Kiosk設定
  'PrintMachineManage': '/Store/BillMachine',//出單機設定  
  'Platform':'/Store/Platform',//平台設定
  'OPSetting':'/PosOrder/OPSetting', //操作設定

  //StoreSetting
  'TableManage': '/PosOrder/TableSetting',//桌位管理
  'Announcement': '/PosOrder/Announcement',//公告管理
  'SpecialDateManage':'/Store/SpecialDate',//特殊營業時間
  'ERPManage':'/Store/ERPSetting',//特殊營業時間
  'EmailSetting': '/Store/EmailSetting',//公告管理
  
  
  //Report
  'ORDInfoManage': '/Report/OrderReport',//訂單管理
  'TodayBusinessReport':'/Report/TodayBusinessReport' ,//'今日報表
  'BusinessReport':'/Report/BusinessReport' ,//'營業報表
  'BusinessTimesReport':'/Report/BusinessTimesReport' ,  
  'InvoiceReport':'/Report/InvoiceReport' ,//'發票開立紀錄
  'InvoiceVoidReport':'/Report/InvoiceVoidReport' ,//'發票作廢紀錄
  'TurnoverReport':'/Report/TurnoverReport' ,//'營收報表
  'SquareAccountsReport':'/Report/SquareAccountsReport' ,//'小節與關帳紀錄
  'InvoiceEmptyReport':'/Report/InvoiceEmptyReport' ,//'空白字軌紀錄
  'ProductAnalyzeReport':'/Report/ProductAnalyzeReport' ,//'商品分析報表
  'AttchAnalyzeReport':'/Report/AttchAnalyzeReport' ,//'附加品項分析報表
  'OperateReport':'/Report/OperationReport' ,//'操作紀錄
  'StaffClockinReport':'/Report/StaffClockinReport' ,//'員工打卡紀錄
  'ClientAnalyzeReport':'/Report/ClientAnalyzeReport' ,//'來客分析報表
  'DiscountAnalyzeReport':'/Report/DiscountAnalyzeReport' ,//'折扣分析報表
  'CashBoxReport':'/Report/CashBoxReport' , // 錢櫃記錄報表
  
  'ORDOnlineCampaign': '/order/activity',//點餐活動設定 
  
  'StoreSettingManage': '/order/store-setting',//門市設定管理
  
  //EOS
  'EOSProductManage': '/EOS/Setting',//商品管理
  'EOSInfoManage': '/EOS/OrderReport',//訂單管理
  'EOSPermissionManage': '/EOS/EmplyeeGroup',//權限設定管理

  //'key2': 'value2',//商品管理tree
  //'key2': 'value2',//折扣碼活動設定
    //'key2': 'value2',//門市印花報表管理  
  // 'basic-info': '/basic-info/list',//權限群組帳號管理
  // 'TableManage': '/Permissions/mylist',//權限管理
};

//額外
export const Dev: NbMenuItem[] = [
  {
    title: '開發中',
    icon: 'menu-2-outline',
    children: [      
      {
        title: '營業時段報表',
        icon: 'shopping-cart-outline',
        link: '/Report/BusinessTimesReport',
        home: true,
      },
      {
        title: '信用卡機設定',
        icon: 'shopping-cart-outline',
        link: '/Store/CreditMachine',
        home: true,
      },
    ]

  }
]


export const EXP: NbMenuItem[] = [
  
  {
    title: '範例',
    icon: 'menu-2-outline',
    children: [
      {
        title: 'E-commerce',
        icon: 'shopping-cart-outline',
        link: '/pages/dashboard',
        home: true,
      },
      {
        title: 'IoT Dashboard',
        icon: 'home-outline',
        link: '/pages/iot-dashboard',
      },
      {
        title: 'FEATURES',
        group: true,
      },
      {
        title: 'Layout',
        icon: 'layout-outline',
        children: [
          {
            title: 'Stepper',
            link: '/pages/layout/stepper',
          },
          {
            title: 'List',
            link: '/pages/layout/list',
          },
          {
            title: 'Infinite List',
            link: '/pages/layout/infinite-list',
          },
          {
            title: 'Accordion',
            link: '/pages/layout/accordion',
          },
          {
            title: 'Tabs',
            pathMatch: 'prefix',
            link: '/pages/layout/tabs',
          },
        ],
      },
      {
        title: 'Forms',
        icon: 'edit-2-outline',
        children: [
          {
            title: 'Form Inputs',
            link: '/pages/forms/inputs',
          },
          {
            title: 'Form Layouts',
            link: '/pages/forms/layouts',
          },
          {
            title: 'Buttons',
            link: '/pages/forms/buttons',
          },
          {
            title: 'Datepicker',
            link: '/pages/forms/datepicker',
          },
        ],
      },
      {
        title: 'UI Features',
        icon: 'keypad-outline',
        link: '/pages/ui-features',
        children: [
          {
            title: 'Grid',
            link: '/pages/ui-features/grid',
          },
          {
            title: 'Icons',
            link: '/pages/ui-features/icons',
          },
          {
            title: 'Typography',
            link: '/pages/ui-features/typography',
          },
          {
            title: 'Animated Searches',
            link: '/pages/ui-features/search-fields',
          },
        ],
      },
      {
        title: 'Modal & Overlays',
        icon: 'browser-outline',
        children: [
          {
            title: 'Dialog',
            link: '/pages/modal-overlays/dialog',
          },
          {
            title: 'Window',
            link: '/pages/modal-overlays/window',
          },
          {
            title: 'Popover',
            link: '/pages/modal-overlays/popover',
          },
          {
            title: 'Toastr',
            link: '/pages/modal-overlays/toastr',
          },
          {
            title: 'Tooltip',
            link: '/pages/modal-overlays/tooltip',
          },
        ],
      },
      {
        title: 'Extra Components',
        icon: 'message-circle-outline',
        children: [
          {
            title: 'Calendar',
            link: '/pages/extra-components/calendar',
          },
          {
            title: 'Progress Bar',
            link: '/pages/extra-components/progress-bar',
          },
          {
            title: 'Spinner',
            link: '/pages/extra-components/spinner',
          },
          {
            title: 'Alert',
            link: '/pages/extra-components/alert',
          },
          {
            title: 'Calendar Kit',
            link: '/pages/extra-components/calendar-kit',
          },
          {
            title: 'Chat',
            link: '/pages/extra-components/chat',
          },
        ],
      },
      {
        title: 'Maps',
        icon: 'map-outline',
        children: [
          {
            title: 'Google Maps',
            link: '/pages/maps/gmaps',
          },
          {
            title: 'Leaflet Maps',
            link: '/pages/maps/leaflet',
          },
          {
            title: 'Bubble Maps',
            link: '/pages/maps/bubble',
          },
          {
            title: 'Search Maps',
            link: '/pages/maps/searchmap',
          },
        ],
      },
      {
        title: 'Charts',
        icon: 'pie-chart-outline',
        children: [
          {
            title: 'Echarts',
            link: '/pages/charts/echarts',
          },
          {
            title: 'Charts.js',
            link: '/pages/charts/chartjs',
          },
          {
            title: 'D3',
            link: '/pages/charts/d3',
          },
        ],
      },
      {
        title: 'Editors',
        icon: 'text-outline',
        children: [
          {
            title: 'TinyMCE',
            link: '/pages/editors/tinymce',
          },
          {
            title: 'CKEditor',
            link: '/pages/editors/ckeditor',
          },
        ],
      },
      {
        title: 'Tables & Data',
        icon: 'grid-outline',
        children: [
          {
            title: 'Smart Table',
            link: '/pages/tables/smart-table',
          },
          {
            title: 'Tree Grid',
            link: '/pages/tables/tree-grid',
          },
        ],
      },
      {
        title: 'Miscellaneous',
        icon: 'shuffle-2-outline',
        children: [
          {
            title: '404',
            link: '/pages/miscellaneous/404',
          },
        ],
      },
      {
        title: 'Auth',
        icon: 'lock-outline',
        children: [
          {
            title: 'Login',
            link: '/auth/login',
          },
          {
            title: 'Register',
            link: '/auth/register',
          },
          {
            title: 'Request Password',
            link: '/auth/request-password',
          },
          {
            title: 'Reset Password',
            link: '/auth/reset-password',
          },
        ],
      },  
      {
        title: 'Example',
        icon: '',
        children: [
          /* {
            title: 'edit',
            link: '/example/edit',
          }, */
          {
            title: 'list',
            link: '/example/list',
          }
        ],
      },
    ],
  }, 
];
